// extracted by mini-css-extract-plugin
export default {"ad_box":"index_ad_box_nU8cr","ad_fixed":"index_ad_fixed_Z0Kjl","ad":"index_ad_Emh4p"};